module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }